import MarketSpecifierMapper from './market-specifier-mapper';

const MarketSpecifierModel = {
    mapper: MarketSpecifierMapper,

    description: {
        type: String,
    },

    name: {
        type: String,
    },

    type: {
        type: String,
    },
};

export default MarketSpecifierModel;
